

import React from 'react';
import { ForgetPassWord } from '../components/ProfileUser/ForgetPassWord';

export const PasswordPage = () => {
  return <ForgetPassWord />
};
